import { SelectItem } from 'primeng';
import { SubscriberAddress } from '../+grid-application-shared/entities/personal-data/subscriberAddress';
import { BaseExportFilter, ExportFilterBy, ExportOrderBy, FilterLogicType } from '../domains/common.domain';

export interface OrderProcessApplication {
  technician_id: string;
  applicant_id: string;
  application_type: string;
  application_sub_type: string;
  assigned_employee_id: string;
  branch?: string[];
  employee?: SelectItem;
  sk_application_type: string;
  sk_application_type_detail: string;
  connection_location: string;
  district: string;
  applicant: string;
  power: string;
  gas: string;
  water: string;
  desired_date: string;
  districtheat: string;
  sk_status: string;
  status: string;
  application_date: string;
  last_changed: string;
  sk_orderprocess_status: string;
  executor: string;
  sk_executor_action: string;
  orderprocess_id: string;
  application_id: number;
  application_ext_id?: string;
  offer_id: string;
  order_id: string;
  invoice_id: string;
  locked: string;
  lockedby: string;
  actions?: string;
  technician: string;
  resource_owner_user_id: string;
  grid_comp_area?: string;
  grid_comp_field?: string;
  grid_comp_field_sector?: string;
  company_name?: string;
  chimney_sweeper_id?: string;
}

export interface OrderProcessApplicationsResponse {
  application: OrderProcessApplication[];
}

export interface UpdateOrderProcess {
  sk_executor_action: string;
}

export interface OrderProcessResponse {
  orderprocess: OrderProcessData[];
}

export interface OrderProcessData {
  orderprocess_id: string;
  sk_orderprocess_status: string;
  last_changed: string;
  executor: string;
  sk_executor_action: string;
  application_id?: number;
  application_ext_id?: string;
  assigned_employee_id: string;
  chimney_sweeper_id?: string;
  offer_id: string;
  order_id: string;
  invoice_id: string;
  offer?: OfferDataObject;
  order?: OrderDataObject;
  invoice?: InvoiceDataObject;
  businesspartner?: SubscriberAddress;
  application_user_id: string;
}

export interface OfferDataObject {
  offer_id: string;
  offer_no: string;
  sk_offer_type: string;
  sk_offer_status: string;
  document: DocumentDataObject[];
}

export interface OrderDataObject {
  order_id: string;
  order_no: string;
  sk_offer_type: string;
  sk_offer_status: string;
  document: DocumentDataObject[];
}

export interface InvoiceDataObject {
  invoice_id: string;
  invoice_no: string;
  sk_offer_type: string;
  sk_offer_status: string;
  document: DocumentDataObject[];
}

export interface DocumentDataObject {
  document_id: string;
  offer_id: string;
  sk_document_type: string;
  name: string;
  filename: string;
  content_type: string;
  application_id?: string;
  application_ext_id?: string;
}

export interface UpdateLockStatusResponse {
  application: {
    application_date: string;
    application_id: string;
    archived: string;
    determinated_price: string;
    last_changed: string;
    locked: string;
    lockedby: string;
    sk_application_type: string;
    sk_status: string;
    user_id: string;
  }[];
}

export interface EmployeeData {
  technician_id: string;
  first_name: string;
  last_name: string;
}

export interface EmployeeListResponse {
  employeeuser: EmployeeData[];
}

export enum OrderProcessAppExportField {
  application_id_text = 'application_id_text',
  location_text = 'location_text',
  applicant_text = 'applicant_text',
  technician_text = 'technician_text',
  type_text = 'type_text',
  company_name_text = 'company_name_text',
  branch_text = 'branch_text',
  process_text = 'process_text',
  last_changed_text = 'last_changed_text',
  desired_date_text = 'desired_date_text',
}

export enum OrderProcessExportCompareType {
  in = 'Contains',
  contains = 'Equal',
  lt = 'LessThan',
  gt = 'GreaterThan',
}

export class OrderProcessExportFilter implements BaseExportFilter {
  filter_by_logic_type: FilterLogicType = FilterLogicType.OR;
  filter_bys: ExportFilterBy[] = [];
  order_bys: ExportOrderBy[] = [];
  language = 'de';
  no_user_restriction = false;
}
